import * as React from 'react';
import { t } from 'i18next';

import { AppConfigurationStore } from '../../stores/AppConfigurationStore';
import { AppHelper } from '../../utils/AppHelper';
import { BaseComponent } from '../BaseComponent';
import { DialogActions } from '../../actions/DialogActions';
import { ImportButton } from './ImportButton';
import { LongButton } from '../LongButton';
import { ProjectManagerStore } from '../../stores/ProjectManagerStore';
import { ProjectSettingsStore } from '../../stores/ProjectSettingsStore';
import { SceneActions } from '../../actions/SceneActions';
import { SceneStore } from '../../stores/SceneStore';
import { SidebarModule, SaveType } from '../../constants/Enums';
import { Stats } from '../../utils/Stats';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { ViewSettingsStore } from '../../stores/ViewSettingsStore';

interface AppProjectButtonsState {
    projectManagerOpen: boolean;
    projectWasSaved: boolean;
    projectHasUnsavedChanged: boolean;
    downloadPossible: boolean;
}

export class AppProjectButtons extends BaseComponent<{}, AppProjectButtonsState> {
    protected importTypicalElement: HTMLInputElement;

    public componentWillMount(): void {
        this.addStoreListener(ProjectManagerStore, this.onChange);
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(SceneStore, this.onChange);
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element {
        return (
            <div className={'long-button-group' + (AppConfigurationStore.getState().inApp ? '' : ' popup-buttons')} key="popup-options-main">
                <LongButton
                    icon="new-button"
                    key="popup-options-new"
                    onClick={this.new}
                    shortBorder={true}
                >
                    {t('New')}
                </LongButton>
                <ImportButton/>
                <LongButton
                    icon="save-button"
                    key="popup-options-export"
                    onClick={() => { AppHelper.sharePboxFile(); }}
                    shortBorder={true}
                    disabled={this.state.projectManagerOpen || !this.state.downloadPossible}
                >
                    <span>{t('Export')}</span>
                </LongButton>
                {AppConfigurationStore.getState().projectManagerAvailable ? (
                    <LongButton
                        icon="icon-disk"
                        disabled={this.state.projectManagerOpen || (!this.state.projectHasUnsavedChanged && !this.state.projectWasSaved)}
                        key="popup-options-save"
                        shortBorder={true}
                        onClick={() => {
                            SceneActions.saveScene(SaveType.DEVICE).then(() => {
                                Stats.sendEvent({
                                    action: 'Save'
                                });
                                ViewSettingsActions.changeHamburger(null);
                            });
                        }}
                    >
                        {t('Save')}
                    </LongButton>
                ) : null}
                {AppConfigurationStore.getState().projectManagerAvailable ? (
                    <LongButton
                        icon="icon-clone"
                        key="popup-options-copy"
                        disabled={!this.state.projectWasSaved || this.state.projectManagerOpen}
                        shortBorder={true}
                        onClick={() => {
                            SceneActions.saveScene(SaveType.COPY).then(() => {
                                Stats.sendEvent({
                                    action: 'Save'
                                });
                            });
                        }}
                    >
                        {t('Save as copy')}
                    </LongButton>
                ) : null}
            </div>
        );
    }

    protected openImportTypicalDialog(): void {
        if (this.importTypicalElement) {
            this.importTypicalElement.click();
        }
    }

    protected onChange = (): void => {
        this.setState({
            projectManagerOpen: ViewSettingsStore.getState().sidebar === SidebarModule.PROJECTS,
            projectWasSaved: ProjectManagerStore.currentProjectWasSaved(),
            projectHasUnsavedChanged: SceneStore.getState().unsavedChanges,
            downloadPossible: SceneStore.getState().elementCount > 0 || ProjectSettingsStore.getState().floorPlan != null
        });
    };

    protected new: () => void = () => {
        DialogActions.showSaveDialog().then(
            (result: SaveType) => {
                ViewSettingsActions.closeMessage();
                ViewSettingsActions.changeHamburger(null);
                SceneActions.newScene(null, result);
            },
            ViewSettingsActions.closeMessage
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/AppProjectButtons.tsx